module.exports = __webpack_public_path__ + "91d0d21a.svg";